import {
  addSummarySheet,
  autoFitColumns,
  createWorkbook,
  downloadWorkbook,
  styleBodyRow,
  styleHeaderRow,
} from '../../platform/excelExport';
import { formatRoleLabel } from '../../platform/roleLabels';

function resolveUnitName(userRow, units) {
  const unitObj = units.find((unit) => unit.id === userRow.unit);
  return unitObj?.unitName || 'Splošno';
}

function addUsersSheet(workbook, users, units) {
  const sheet = workbook.addWorksheet('Uporabniki');
  sheet.columns = [
    { header: 'Elektronski naslov', key: 'email', width: 32 },
    { header: 'Prikazno ime', key: 'displayName', width: 28 },
    { header: 'Ime', key: 'firstName', width: 18 },
    { header: 'Priimek', key: 'lastName', width: 18 },
    { header: 'Telefon', key: 'phone', width: 16 },
    { header: 'Delovno mesto', key: 'jobPosition', width: 22 },
    { header: 'Oddelek / področje dela', key: 'workArea', width: 24 },
    { header: 'Enota', key: 'unit', width: 24 },
    { header: 'Vloga', key: 'role', width: 22 },
  ];

  styleHeaderRow(sheet.getRow(1));

  users.forEach((userRow, index) => {
    const row = sheet.getRow(index + 2);
    row.getCell(1).value = userRow.email || '';
    row.getCell(2).value = userRow.displayName || '';
    row.getCell(3).value = userRow.firstName || '';
    row.getCell(4).value = userRow.lastName || '';
    row.getCell(5).value = userRow.phone || '';
    row.getCell(6).value = userRow.jobPosition || '';
    row.getCell(7).value = userRow.workArea || '';
    row.getCell(8).value = resolveUnitName(userRow, units);
    row.getCell(9).value = formatRoleLabel(userRow.role);
    styleBodyRow(row, { alt: index % 2 === 1 });
  });

  autoFitColumns(sheet, {
    email: 34,
    displayName: 28,
    firstName: 18,
    lastName: 18,
    phone: 16,
    jobPosition: 22,
    workArea: 24,
    unit: 24,
    role: 22,
  });
}

export async function exportUsersToExcel({ users, units, tenantDisplayName }) {
  const workbook = createWorkbook();
  addSummarySheet(workbook, {
    title: 'Seznam uporabnikov',
    rows: [
      ['Organizacija', tenantDisplayName || '—'],
      ['Število uporabnikov', users.length],
      ['Izvoženo', new Date().toLocaleString('sl-SI')],
    ],
    labelColumnWidth: 22,
  });
  addUsersSheet(workbook, users, units);
  await downloadWorkbook(workbook, 'Seznam_uporabnikov.xlsx');
}
